<template>
	<div>
		<v-textarea label="HTML" placeholder="HTML" v-model="question.html"></v-textarea>
		<v-checkbox v-model="question.renderAs" label="Format as checkit header" value="cn_header"></v-checkbox>
	</div>
</template>
<script>
	export default {
		name: "FieldHTML", 
		props: {
			question: {type: Object} 
		},

	}
</script>